import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function CategorySection() {
  const { t } = useTranslation();

  const handleCategoryClick = (url: string) => {
    window.open(url, "_blank", "noopener,nofollow");
  };

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3 md:mb-4">
            {t("categories.title")}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            {t("categories.subtitle")}
          </p>
        </div>

        <div className="relative mb-10 md:mb-14 max-w-md mx-auto">
          <select
            onChange={(e) => {
              if (e.target.value) handleCategoryClick(e.target.value);
            }}
            defaultValue=""
            className="w-full px-5 py-3.5 text-sm md:text-base text-foreground-700 bg-background-50 border-2 border-background-300/60 rounded-full appearance-none cursor-pointer focus:outline-none focus:border-primary-400 transition-colors duration-200"
          >
            <option value="" disabled>{t("categories.select_placeholder")}</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.url}>
                {cat.name}
              </option>
            ))}
          </select>
          <div className="absolute right-5 top-1/2 -translate-y-1/2 pointer-events-none">
            <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => handleCategoryClick(cat.url)}
              className="group flex flex-col items-center gap-3 p-3 md:p-4 bg-background-100/70 hover:bg-background-100 rounded-lg transition-all duration-300 cursor-pointer hover:scale-[1.03]"
            >
              <div className="w-full aspect-square rounded-lg overflow-hidden bg-background-200/50">
                <img
                  src={cat.imageUrl}
                  alt={cat.name}
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-700 text-center leading-tight">
                {cat.name}
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}